import { FeaturedBlogPosts } from '@/components/blog/FeaturedBlogPosts'
import { LiveRoomsStrip } from '@/components/rooms/LiveRoomsStrip'
import { MetaTags } from '@/components/seo/MetaTags'
import { StructuredData } from '@/components/seo/StructuredData'
import { useMessageCycler } from '@/hooks/useMessageCycler'
import { PublicLayout } from '@/components/layout/PublicLayout'
import { useAuthStore } from '@/store/authStore'

export function HomePage() {
  const { message } = useMessageCycler(6000)
  const authed = useAuthStore((s) => s.isAuthenticated())

  return (
    <PublicLayout>
      <MetaTags
        title="DersKaynağı — Birlikte Çalışan Öğrencilerin Yeri | TYT ve AYT"
        description="Yalnız çalışmak bitti: günlük planını yap, canlı odaya katıl, arkadaşlarınla aynı anda çalış. İlerlemeni Akış'ta paylaş, serini koru — TYT ve AYT hazırlığında beraber ilerle."
        keywords="TYT, AYT, üniversite sınavı, çalışma arkadaşları, canlı çalışma odası, çalışma planı, birlikte çalışma, deneme sınavı, sınav hazırlık"
        canonical="/"
      />
      <StructuredData
        type="WebSite"
        data={{
          name: 'DersKaynağı',
          url: 'https://derskaynagi.com',
          description: 'Günlük plan, canlı çalışma odaları, arkadaşlar ve akışla öğrencilerin birlikte çalıştığı yer. TYT ve AYT hazırlığı beraber kolay.',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://derskaynagi.com/kurslar/search?q={search_term_string}',
            'query-input': 'required name=search_term_string'
          }
        }}
      />
      <div className="bg-gradient-to-b from-primary-50 via-accent-50 to-white">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">

            <div className="inline-flex items-center gap-4 bg-blue/25 backdrop-blur-xl px-[30px] py-3 rounded-[50px] text-sm font-bold mb-[35px] border-2 border-white/40 shadow-[0_8px_32px_rgba(0,0,0,0.1)] animate-[slideDown_0.8s_ease-out]">
            <div className='text-4xl'>🎓</div>
                {message}
            </div>
          <h2 className="text-5xl md:text-6xl font-extrabold heading-gradient-primary mb-6 animate-fade-in md:leading-loose"  >
            Yalnız çalışmak bitti
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto">
            Günlük planını yap, canlı odaya katıl, arkadaşlarınla aynı anda çalış.
            Serini koru, ilerlemeni Akış'ta paylaş — TYT ve AYT maratonu beraber kolay.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href={authed ? '/student/plan' : '/welcome'}
              className="btn btn-primary text-lg px-10 py-4 shadow-glow-primary hover:scale-105"
            >
              {authed ? 'Planına Devam Et' : 'Ücretsiz Başla'}
            </a>
            <a
              href="/rooms"
              className="btn btn-secondary text-lg px-10 py-4 shadow-glow-accent hover:scale-105"
            >
              Canlı Odalara Katıl
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-20">
          <div className="card text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">📅</div>
            <h3 className="text-xl font-bold mb-2 text-primary-500">Günlük Çalışma Planı</h3>
            <p className="text-gray-600">Her sabah hangi ders, hangi saat belli. Enerjine göre küçülür, hiç gün boş geçmez.</p>
          </div>
          <div className="card text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">🔴</div>
            <h3 className="text-xl font-bold mb-2 text-accent-500">Canlı Çalışma Odaları</h3>
            <p className="text-gray-600">Bir odaya katıl, kronometreyi başlat — aynı anda, sessizce, ama hiç yalnız değil.</p>
          </div>
          <div className="card text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">👥</div>
            <h3 className="text-xl font-bold mb-2 text-primary-500">Arkadaşlar & Duvar</h3>
            <p className="text-gray-600">Arkadaşlık kur, duvarında ilerlemeni paylaş; netleri ve serileri birbirinize görün.</p>
          </div>
          <div className="card text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">🗞️</div>
            <h3 className="text-xl font-bold mb-2 text-accent-500">Akış & Keşfet</h3>
            <p className="text-gray-600">Arkadaşların ne çalışıyor, kim senin ritminde? Akışta takip et, Keşfet'te bul.</p>
          </div>
          <div className="card text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">🎯</div>
            <h3 className="text-xl font-bold mb-2 text-primary-500">Puan, Rozet, Seri</h3>
            <p className="text-gray-600">Emeğin görünür olsun: puan, rozet, liderlik tablosu ve çalışma serisiyle motivasyon yerinde.</p>
          </div>
          <div className="card text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">📚</div>
            <h3 className="text-xl font-bold mb-2 text-accent-500">Dersler & Denemeler</h3>
            <p className="text-gray-600">TYT ve AYT için konu anlatımı, quizler ve deneme sınavları seni bekliyor.</p>
          </div>
        </div>

        <LiveRoomsStrip />
        <FeaturedBlogPosts />
      </main>
    </div>
    </PublicLayout>
  )
}
